import { render, staticRenderFns } from "./BtnBlob.vue?vue&type=template&id=5907b1fe&scoped=true"
import script from "./BtnBlob.vue?vue&type=script&lang=js"
export * from "./BtnBlob.vue?vue&type=script&lang=js"
import style0 from "./BtnBlob.vue?vue&type=style&index=0&id=5907b1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907b1fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
